// Theme context key for provide/inject
export const THEME_KEY = Symbol('ThemeContext');